<div class="alert-wrapper" [ngClass]="type">
  <span>{{ message  }}</span>
  <fa-icon *ngIf="displayIcon" [icon]="faTimes" (click)="close.emit()"></fa-icon>
</div>
